import { initializePaddle } from "@paddle/paddle-js";
import { PADDLE_ENVIRONMENT, PADDLE_CLIENT_TOKEN } from "../../src/helpers/paddleClient.js";
// This page is the Paddle account's default payment link, so Paddle.js has to be here.
// Paddle appends ?_ptxn=<transaction id> to this URL for invoice payments, for the
// "update your payment details" link in its subscription emails and for every dunning
// email it sends. An initialized Paddle.js opens the checkout for that transaction on
// its own - nothing below reads the parameter, and nothing should.
//
// Initialized unconditionally rather than only when _ptxn is present: Paddle fetches
// this URL to confirm the script is installed (Retain's setup check, and domain
// review), and Paddle.js that only appears for one query string fails those.
//
// Plain <script> rather than an island: Astro bundles this and it runs on load, where a
// hydrated component would only initialize once React has mounted - and the visitor
// arriving here is mid-payment, staring at a pricing page until the overlay appears.
if (PADDLE_CLIENT_TOKEN) {
	initializePaddle({
		environment: PADDLE_ENVIRONMENT,
		token: PADDLE_CLIENT_TOKEN
	}).catch((error) => {
		// Nothing to show the visitor - a blocked or failed load means no overlay, and the
		// page behind it is still a perfectly good pricing page.
		console.error("Paddle.js failed to initialize", error);
	});
}